module.exports = __webpack_public_path__ + "static/media/wildtier.4a6be328.svg";